"use client"

import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "../../lib/utils"

type ProgressProps = React.ComponentProps<typeof ProgressPrimitive.Root> & {
  variant?: 'black' | 'white'
}

function Progress({
  className,
  value,
  variant = 'black',
  ...props
}: ProgressProps) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        "relative h-[2px] w-full overflow-hidden rounded-full",
        variant === 'black' ? "bg-[rgba(59,59,59,0.20)]" : "bg-[rgba(255,255,255,0.20)]",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          "h-full w-full flex-1 transition-all bg-gradient-to-r from-transparent",
          variant === 'black' ? "to-black" : "to-white"
        )}
        style={{ 
          transform: `translateX(-${100 - (value || 0)}%)`,
        }}
      />
    </ProgressPrimitive.Root>
  )
}

export { Progress }
